import { render } from "./ProcessOwnerPicker.vue?vue&type=template&id=4ccd6615&scoped=true&ts=true"
import script from "./ProcessOwnerPicker.vue?vue&type=script&lang=ts"
export * from "./ProcessOwnerPicker.vue?vue&type=script&lang=ts"

import "./ProcessOwnerPicker.vue?vue&type=style&index=0&id=4ccd6615&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccd6615"]])

export default __exports__